import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const FounderPortrait = ({ src = "/founder/zahir-patel-portrait.webp", fallback = "/founder/zahir-patel-portrait.jpg", alt, testid = "founder-portrait" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <div ref={ref} className="relative" data-testid={testid}>
      <div className="absolute -inset-10 bg-[radial-gradient(circle_at_50%_30%,rgba(212,175,55,0.35),transparent_60%)] blur-2xl" />
      <div className="relative chamfer border border-[#d4af37]/40 bg-gradient-to-b from-[#d4af37]/40 to-[#d4af37]/5 p-[1px]">
        <div className="chamfer relative overflow-hidden aspect-[4/5] bg-black">
          <motion.picture style={{ y }} className="absolute inset-[-7%] block">
            <source srcSet={src} type="image/webp" />
            <img src={fallback} alt={alt} className="w-full h-full object-cover object-[50%_20%]" loading="lazy" />
          </motion.picture>
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        </div>
      </div>
      <span className="absolute -top-3 -left-3 w-10 h-10 border-t-2 border-l-2 border-[#d4af37]" />
      <span className="absolute -bottom-3 -right-3 w-10 h-10 border-b-2 border-r-2 border-[#d4af37]" />
    </div>
  );
};
